import React, { PureComponent } from 'react';
import DocumentTitle from 'react-document-title';
import cn from 'classnames';

import ViewedHotelsUpdater from '../../containers/ViewedHotelsUpdater';
import ProgressBar from '../../containers/ProgressBar';
import SearchPageDesktop from './desktop';
import SearchPageMobile from './mobile';

type SearchProps = {
  title: string;
  isMobile: boolean;
  isHotelOnly: boolean;
};

class Search extends PureComponent<SearchProps> {
  get title() {
    const { title, isHotelOnly } = this.props;
    const offersType = isHotelOnly ? 'Забронировать отель' : 'Купить тур';
    return `${title} | ${offersType} онлайн`;
  }

  render() {
    const { isMobile } = this.props;
    const SearchPageComponent = isMobile ? SearchPageMobile : SearchPageDesktop;

    return (
      <DocumentTitle title={this.title}>
        <div className={cn('search-page', { mobile: isMobile })}>
          <ProgressBar isMobile={isMobile} />
          <SearchPageComponent />
          <ViewedHotelsUpdater />
        </div>
      </DocumentTitle>
    );
  }
}

export default Search;
